import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import PortfolioDetailsMain from "./PortfolioDetailsMain";
import Footer from "../../components/Footer";

const PortfolioDetails = () => {
  return (
    <>
      <HeaderFour />

      <PortfolioDetailsMain />

      <Footer />
    </>
  );
};

export default PortfolioDetails;
